import { createContext, useState } from 'react';
import EditorJS from '@editorjs/editorjs';

type ContextState = {
  setInstanceFromEditorJs: (editorJs: EditorJS) => void;
  instanceEditorJs: EditorJS | null;
};

const initialState: ContextState = {
  setInstanceFromEditorJs: () => {
  },
  instanceEditorJs: null,
};

export const ScriptEditorJSContext = createContext<ContextState>(initialState);

export const useScriptEditorContext = (): ContextState => {
  const [instanceEditorJs, setInstanceFromEditorJs] = useState<EditorJS | null>(null);
  return { instanceEditorJs, setInstanceFromEditorJs };
};
